import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/auth/AuthProvider';
import { router } from '@/app/router';
import { createQueryClient } from '@/lib/queryClient';
import { applyTheme, getTheme } from '@/lib/theme';
import '@/styles/index.css';

applyTheme(getTheme());
const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
      <Toaster position="top-right" richColors={false} closeButton toastOptions={{ className: 'font-sans text-[13px]' }} />
    </QueryClientProvider>
  </StrictMode>,
);
